import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

/**
 * ------------------------------------
 * FETCH USER PAYMENT HISTORY
 * ------------------------------------
 */
export const fetchPaymentHistory = createAsyncThunk(
  "paymentHistory/fetchHistory",
  async ({ page = 1, limit = 20, paymentFor }, { rejectWithValue }) => {
    try {
      const params = { page, limit };
      if (paymentFor) params.paymentFor = paymentFor;

      const res = await api.get("api/payment/user/history", { params });

      return res.data.data; // { payments, pagination }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch payment history"
      );
    }
  }
);

/**
 * ------------------------------------
 * FETCH PAYMENT DETAILS BY ORDER ID
 * ------------------------------------
 */
export const fetchPaymentDetails = createAsyncThunk(
  "paymentHistory/fetchDetails",
  async (orderId, { rejectWithValue }) => {
    try {
      const res = await api.get(`api/payment/${orderId}`);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch payment details"
      );
    }
  }
);
